/**
 * 预警监控 API 服务
 * 负责与后端接口交互，获取库存/资金预警数据
 */
import request from '@/utils/request'
import { generateSign, generateRequestId } from '@/utils/sign'

/** API 配置常量 */
var API_CONFIG = {
  url: '/supplier/supplier/queryAvailableInfo',
  md5Key: 'ctai80cfbk67k4ojhkzqnnytsbvtuyo3'
}

/**
 * 省级行政区全称列表（含「全国」及 34 个省级行政区）
 * 顺序：全国 → 华北地区 → 东北 … 末位港澳台
 */
export var PROVINCE_LIST = [
  '北京市',
  '天津市',
  '河北省',
  '山西省',
  '内蒙古自治区',
  '辽宁省',
  '吉林省',
  '黑龙江省',
  '上海市',
  '江苏省',
  '浙江省',
  '安徽省',
  '福建省',
  '江西省',
  '山东省',
  '河南省',
  '湖北省',
  '湖南省',
  '广东省',
  '广西壮族自治区',
  '海南省',
  '重庆市',
  '四川省',
  '贵州省',
  '云南省',
  '西藏自治区',
  '陕西省',
  '甘肃省',
  '青海省',
  '宁夏回族自治区',
  '新疆维吾尔自治区',
  '台湾省',
  '香港特别行政区',
  '澳门特别行政区'
]

/**
 * 查询可用库存/资金信息
 *
 * @param {Object} options - 查询参数
 * @param {string} options.appid - 应用ID（从URL参数获取）
 * @param {string} options.deductModel - 扣减模式：'0'-库存(电子券), '1'-资金(资金池)
 * @param {string} options.provinceName - 省份名称
 * @returns {Promise<Array>} 预警数据列表
 */
export function queryAvailableInfo(options) {
  var timestamp = Date.now()
  var requestId = generateRequestId()

  var params = {
    appid: options.appid,
    deductModel: options.deductModel,
    provinceName: options.provinceName,
    requestId: requestId,
    timestamp: timestamp
  }

  params.sign = generateSign(params, API_CONFIG.md5Key)

  return request({
    url: API_CONFIG.url,
    method: 'post',
    data: params
  })
}
